import styled from 'styled-components';
import { Icons } from '@shopline/dashboard-ui';

const CircleTickIcon = styled(Icons.Solid.CircleTick)`
  width: 16px;
  height: 16px;
`;

export default CircleTickIcon;
